import { EObject } from '../../models/EObject';
import { CLASS_ID_PACKAGE } from '../constants';

export function buildGetParams(url: string, searchParamsAtributes: any): string {
  const urlInstance = new URL(url);
  if (urlInstance.hash) {
    let hash = urlInstance.hash.replace('#/', '') as any;
    if (urlInstance.hash.indexOf('?') === -1) {
      hash = [hash, ''];
    } else {
      hash = hash.split('?');
    }
    const urlHashParams = new URLSearchParams(hash[hash.length - 1]);

    Object.keys(searchParamsAtributes).forEach((key) => {
      if (searchParamsAtributes[key] && !urlHashParams.get(key)) {
        urlHashParams.append(key, searchParamsAtributes[key]);
      }
    });

    hash[hash.length - 1] = urlHashParams.toString();
    urlInstance.hash = `#/${hash.join('?')}`;
  } else {
    Object.keys(searchParamsAtributes).forEach((key) => {
      if (searchParamsAtributes[key] && !urlInstance.searchParams.get(key)) {
        urlInstance.searchParams.append(key, searchParamsAtributes[key]);
      }
    });
  }
  return urlInstance.toString();
}

export type URLInfosType = {
  classId: string;
  methodIdentifier: string;
  objectId: string;
};

export function extractInfosByURL(url: string, urlCompleted?: boolean): URLInfosType {
  // TODO: Realizar extração de métodos sem _classId
  if (!url || url.indexOf(CLASS_ID_PACKAGE) === -1) {
    return {
      classId: null,
      methodIdentifier: null,
      objectId: null,
    };
  }
  const infos = url.split('/');

  let classId = urlCompleted ? infos?.[7] : infos?.[1];
  let objectId = urlCompleted ? infos?.[9]?.split('?')[0] : infos?.[3]?.split('?')[0];
  const methodIdentifier = urlCompleted ? removeQueryParams(infos?.[8]) : removeQueryParams(infos?.[2]);

  classId = classId && EObject.isEObjecId(classId) ? classId : null;
  objectId = objectId && EObject.isEObjecId(objectId) ? objectId : null;

  return {
    classId,
    methodIdentifier,
    objectId,
  };
}

export function extractClassIdByURL(url: string): string {
  return url.split('/')?.[7];
}

export function removeQueryParams(path: string): string {
  if (!path) return path;

  const queryParamsStartsIndex = path.indexOf('?');
  if (queryParamsStartsIndex === -1) return path;

  return path.slice(0, queryParamsStartsIndex);
}
